import Cookies from 'js-cookie'
// import Config from '@/utils/globalSettings'

const TokenKey = 'DC-ADMIN-TOEKN'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token, rememberMe) {
  if (rememberMe) {
    return Cookies.set(TokenKey, token, { expires: 1 })
  } else return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js